import React from 'react';
import classNames from 'classnames';
import { Card, Icon } from 'ui';

const Callout = ({ title, children, actions, icon, className, iconClass }) => (
  <Card className={classNames('llui-Callout', className)}>
    <Card.Content padding="large" className="d-f m-fd-c ai-fs w-fill">
      <div className="d-f ai-c jc-sb mr-16">
        {icon && (
          <Icon
            className={classNames('llui-Callout-icon', iconClass)}
            name={icon}
          />
        )}
      </div>
      <div className="llui-Callout-content">
        <header className="llui-Callout-title">
          <h1>{title}</h1>
        </header>
        <section>{children}</section>
        <footer className="llui-Callout-footer">{actions}</footer>
      </div>
    </Card.Content>
  </Card>
);

export default Callout;
